export var states = [{
    'name': 'Auckland',
    'abbreviation': 'ALD'
}, {
    'name': 'Bay of Plenty',
    'abbreviation': 'BOP'
}, {
    'name': 'Canterbury',
    'abbreviation': 'CAN'
}, {
    'name': 'Gisborne',
    'abbreviation': 'GIS'
}, {
    'name': 'Hawke\'s Bay',
    'abbreviation': 'HB'
}, {
    'name': 'Marlborough',
    'abbreviation': 'MRL'
}, {
    'name': 'Manawatu-Wanganui',
    'abbreviation': 'MW'
}, {
    'name': 'Nelson',
    'abbreviation': 'NEL'
}, {
    'name': 'Northland',
    'abbreviation': 'NLD'
}, {
    'name': 'Otago',
    'abbreviation': 'OTA'
}, {
    'name': 'Southland',
    'abbreviation': 'SLD'
}, {
    'name': 'Taranaki',
    'abbreviation': 'TAR'
}, {
    'name': 'Tasman',
    'abbreviation': 'TSN'
}, {
    'name': 'Waikato',
    'abbreviation': 'WAI'
}, {
    'name': 'West Coast',
    'abbreviation': 'WC'
}, {
    'name': 'Wellington',
    'abbreviation': 'WEL'
}];

export default states;



//////////////////
// WEBPACK FOOTER
// ./data/nz.states.js
// module id = 207
// module chunks = 0